import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  invoiceList: { loading: false, data: null, error: null },
  generatedCreditNoteList: { loading: false, data: null, error: null },
  draftCreditNoteList: { loading: false, data: null, error: null },
  createCreditNote: { loading: false, data: null, error: null },
  deleteCreditNote: { loading: false, data: null, error: null },
  creditNoteDetailList: { loading: false, data: null, error: null },
  creditNoteUpdateStage: { loading: false, data: null, error: null },
  editCreditNote: { loading: false, data: null, error: null },
  ecreditNote: { loading: false, data: null, error: null },
  cancelCreditNote: { loading: false, data: null, error: null },
  finiancialCreditNote: { loading: false, data: null, error: null },
};

export const CreditNoteSlice = createSlice({
  name: "creditNote",
  initialState,
  reducers: {
    fetchCNInvoiceListRequest: (state, action) => {
      state.invoiceList.loading = true;
      state.invoiceList.error = null;
    },
    fetchCNInvoiceListSuccess: (state, action) => {
      state.invoiceList.data = action.payload;
      state.invoiceList.loading = false;
      state.invoiceList.error = null;
    },
    fetchCNInvoiceListFailure: (state, action) => {
      state.invoiceList.data = null;
      state.invoiceList.loading = false;
      state.invoiceList.error = action.payload;
    },

    fetchGeneratedCreditNoteListRequest: (state, action) => {
      state.generatedCreditNoteList.loading = true;
      state.generatedCreditNoteList.error = null;
    },
    fetchGeneratedCreditNoteListSuccess: (state, action) => {
      state.generatedCreditNoteList.data = action.payload;
      state.generatedCreditNoteList.loading = false;
      state.generatedCreditNoteList.error = null;
    },
    fetchGeneratedCreditNoteListFailure: (state, action) => {
      state.generatedCreditNoteList.data = null;
      state.generatedCreditNoteList.loading = false;
      state.generatedCreditNoteList.error = action.payload;
    },

    fetchDraftCreditNoteListRequest: (state, action) => {
      state.draftCreditNoteList.loading = true;
      state.draftCreditNoteList.error = null;
    },
    fetchDraftCreditNoteListSuccess: (state, action) => {
      state.draftCreditNoteList.data = action.payload;
      state.draftCreditNoteList.loading = false;
      state.draftCreditNoteList.error = null;
    },
    fetchDraftCreditNoteListFaliure: (state, action) => {
      state.draftCreditNoteList.data = null;
      state.draftCreditNoteList.loading = false;
      state.draftCreditNoteList.error = action.payload;
    },

    createCreditNoteRequest: (state, action) => {
      state.createCreditNote.loading = true;
      state.createCreditNote.error = null;
    },
    createCreditNoteSuccess: (state, action) => {
      state.createCreditNote.data = action.payload;
      state.createCreditNote.loading = false;
      state.createCreditNote.error = null;
    },
    createCreditNoteFaliure: (state, action) => {
      console.log(action);
      state.createCreditNote.data = null;
      state.createCreditNote.loading = false;
      state.createCreditNote.error = action.payload;
    },
    resetCreditNote: (state, action) => {
      state.createCreditNote.data = null;
      state.createCreditNote.loading = false;
      state.createCreditNote.error = null;

      state.creditNoteUpdateStage.data = null;
      state.creditNoteUpdateStage.loading = false;
      state.creditNoteUpdateStage.error = null;

      state.editCreditNote.data = null;
      state.editCreditNote.loading = false;
      state.editCreditNote.error = null;

      state.deleteCreditNote.data = null;
      state.deleteCreditNote.loading = false;
      state.deleteCreditNote.error = null;

      state.ecreditNote.data = null;
      state.ecreditNote.loading = false;
      state.ecreditNote.error = null;

      state.finiancialCreditNote.data = null;
      state.finiancialCreditNote.loading = false;
      state.finiancialCreditNote.error = null;
    },

    deleteCreditNoteRequest: (state, action) => {
      state.deleteCreditNote.loading = true;
      state.deleteCreditNote.error = null;
    },
    deleteCreditNoteSuccess: (state, action) => {
      state.deleteCreditNote.data = action.payload;
      state.deleteCreditNote.loading = false;
      state.deleteCreditNote.error = null;
      state.draftCreditNoteList = updateDeleteDraftCreditNoteSuccess(
        action.payload,
        {
          ...state.draftCreditNoteList,
        }
      );
    },
    deleteCreditNoteFaliure: (state, action) => {
      state.deleteCreditNote.data = null;
      state.deleteCreditNote.loading = false;
      state.deleteCreditNote.error = action.payload;
    },

    fetchCreditNoteDetailListRequest: (state, action) => {
      state.creditNoteDetailList.loading = true;
      state.creditNoteDetailList.error = null;
    },
    fetchCreditNoteDetailListSuccess: (state, action) => {
      state.creditNoteDetailList.data = action.payload;
      state.creditNoteDetailList.loading = false;
      state.creditNoteDetailList.error = null;
    },
    fetchCreditNoteDetailListFailure: (state, action) => {
      state.creditNoteDetailList.data = null;
      state.creditNoteDetailList.loading = false;
      state.creditNoteDetailList.error = action.payload;
    },

    updateCreditNoteStageRequest: (state, action) => {
      state.creditNoteUpdateStage.loading = true;
      state.creditNoteUpdateStage.error = null;
    },
    updateCreditNoteStageSuccess: (state, action) => {
      state.creditNoteUpdateStage.data = action.payload;
      state.creditNoteUpdateStage.loading = false;
      state.creditNoteUpdateStage.error = null;
      state.creditNoteDetailList = updateCreditNoteSuccessStage(
        action.payload,
        {
          ...state.creditNoteDetailList,
        }
      );
    },
    updateCreditNoteStageFaliure: (state, action) => {
      state.creditNoteUpdateStage.data = null;
      state.creditNoteUpdateStage.loading = false;
      state.creditNoteUpdateStage.error = action.payload;
    },

    editCreditNoteRequest: (state, action) => {
      state.editCreditNote.loading = true;
      state.editCreditNote.error = null;
    },
    editCreditNoteSuccess: (state, action) => {
      state.editCreditNote.data = action.payload;
      state.editCreditNote.loading = false;
      state.editCreditNote.error = null;
    },
    editCreditNoteFaliure: (state, action) => {
      state.editCreditNote.data = null;
      state.editCreditNote.loading = false;
      state.editCreditNote.error = action.payload;
    },
    fetchEcreditNoteRequest: (state, action) => {
      state.ecreditNote.loading = true;
      state.ecreditNote.error = null;
    },
    fetchEcreditNoteSuccess: (state, action) => {
      state.ecreditNote.data = action.payload;
      state.ecreditNote.loading = false;
      state.ecreditNote.error = null;
      //TODO: success update
    },
    fetchEcreditNoteFailure: (state, action) => {
      state.ecreditNote.data = null;
      state.ecreditNote.loading = false;
      state.ecreditNote.error = action.payload;
    },
    fetchCancelCreditNoteRequest: (state, action) => {
      state.cancelCreditNote.loading = true;
      state.cancelCreditNote.error = null;
    },
    fetchCancelCreditNoteSuccess: (state, action) => {
      state.cancelCreditNote.data = action.payload;
      state.cancelCreditNote.loading = false;
      state.cancelCreditNote.error = null;
      //TODO: success update
    },
    fetchCancelCreditNoteFailure: (state, action) => {
      state.cancelCreditNote.data = null;
      state.cancelCreditNote.loading = false;
      state.cancelCreditNote.error = action.payload;
    },
    fetchFiniancialCreditNoteRequest: (state, action) => {
      state.finiancialCreditNote.loading = true;
      state.finiancialCreditNote.error = null;
    },
    fetchFiniancialCreditNoteSuccess: (state, action) => {
      state.finiancialCreditNote.data = action.payload;
      state.finiancialCreditNote.loading = false;
    },
    fetchFiniancialCreditNoteFailure: (state, action) => {
      state.finiancialCreditNote.data = null;
      state.finiancialCreditNote.loading = false;
      state.finiancialCreditNote.error = action.payload;
    },
  },
});

function updateDeleteDraftCreditNoteSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.filter((target) => {
    return target._id != dataToUpdate.data;
  });
  return state;
}
function updateCreditNoteSuccessStage(dataToUpdate, state) {
  console.log(dataToUpdate, "datato update");
  console.log(state, "state");
  state.data.data = state.data.data.map((target) => {
    if (target._id !== dataToUpdate._id) return target;
    return { ...target, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchCNInvoiceListRequest,
  fetchCNInvoiceListSuccess,
  fetchCNInvoiceListFailure,

  fetchGeneratedCreditNoteListRequest,
  fetchGeneratedCreditNoteListSuccess,
  fetchGeneratedCreditNoteListFailure,

  fetchDraftCreditNoteListRequest,
  fetchDraftCreditNoteListSuccess,
  fetchDraftCreditNoteListFaliure,

  createCreditNoteRequest,
  createCreditNoteSuccess,
  createCreditNoteFaliure,

  deleteCreditNoteRequest,
  deleteCreditNoteSuccess,
  deleteCreditNoteFaliure,

  fetchCreditNoteDetailListRequest,
  fetchCreditNoteDetailListSuccess,
  fetchCreditNoteDetailListFailure,

  updateCreditNoteStageRequest,
  updateCreditNoteStageSuccess,
  updateCreditNoteStageFaliure,

  editCreditNoteRequest,
  editCreditNoteSuccess,
  editCreditNoteFaliure,

  fetchEcreditNoteRequest,
  fetchEcreditNoteSuccess,
  fetchEcreditNoteFailure,

  fetchCancelCreditNoteRequest,
  fetchCancelCreditNoteSuccess,
  fetchCancelCreditNoteFailure,

  fetchFiniancialCreditNoteRequest,
  fetchFiniancialCreditNoteSuccess,
  fetchFiniancialCreditNoteFailure,

  resetCreditNote,
} = CreditNoteSlice.actions;

export const getinvoiceListState = (store) => store.creditNote?.invoiceList;

export const getGeneratedCreditNoteListState = (store) =>
  store.creditNote?.generatedCreditNoteList;

export const getDraftCreditNoteListState = (store) =>
  store.creditNote.draftCreditNoteList;

export const createCreditNoteState = (store) =>
  store.creditNote.createCreditNote;

export const getCreditNoteDetailListState = (store) =>
  store.creditNote.creditNoteDetailList;

export const editCreditNoteState = (store) => store.creditNote.editCreditNote;
export const getCreditNoteUpdateState = (store) =>
  store.creditNote.creditNoteUpdateStage;

export const ecreditnoteStage = (store) => store.creditNote.ecreditNote;
export const cancelCreditnoteStage = (store) =>
  store.creditNote.cancelCreditNote;
export const finiancialCreditNoteStage = (store) =>
  store.creditNote.finiancialCreditNote;
export default CreditNoteSlice.reducer;
